import { publish } from "./events";

export const OPEN_ATTACHMENT_EVENT = "openAttachment";

export const IMAGE_SUFFIXES = ["png", "jpg", "jpeg", "gif", "webp"];

// Images are previewed with <img>: an <embed> scales them through a nested image document,
// which left the thumbnails blurry and distorted
export const isImageAttachment = (source, suffix) =>
  IMAGE_SUFFIXES.includes((suffix || "").toLowerCase()) || !!source?.startsWith("data:image/");

// Shows an attachment in the portal's viewer (components/AttachmentViewer, mounted once in
// Layout) instead of an about:blank tab. `source` is the file's data URL (or a plain URL).
export const openAttachment = (source, filename, suffix) => {
  if (!source) return;
  publish(OPEN_ATTACHMENT_EVENT, { source, filename, suffix });
};
